// extracted by mini-css-extract-plugin
module.exports = {"svgRegionMapContainer":"SVGRegionMap_svgRegionMapContainer__3gX5b","svgRegionMap":"SVGRegionMap_svgRegionMap__Gnnib"};